<template>
  <div class="lead-bar">
    <a class="lead-btn lead-phone" href="tel:+380682772822">Подзвонити</a>
    <a class="lead-btn lead-telegram" href="https://t.me/MobiFIXPRO_bot" target="_blank" rel="noopener">Telegram</a>
    <router-link class="lead-btn lead-order" to="/orders/create">Замовити ремонт</router-link>
  </div>
</template>

<style scoped>
.lead-bar {
  position: fixed;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  z-index: 500;
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 18px;
  background: rgba(22, 20, 45, 0.88);
  backdrop-filter: blur(14px);
  box-shadow: 0 18px 40px rgba(17, 15, 40, 0.28);
}

.lead-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 132px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 800;
  transition: transform 0.18s ease, opacity 0.18s ease;
}

.lead-btn:hover {
  transform: translateY(-1px);
  opacity: 0.94;
}

.lead-phone { background: linear-gradient(135deg, #1d9e75, #2cc48b); }
.lead-telegram { background: linear-gradient(135deg, #1694f3, #2bc1ff); }
.lead-order { background: linear-gradient(135deg, #534ab7, #7f77dd); }

@media (max-width: 700px) {
  .lead-bar {
    left: 10px;
    right: 10px;
    bottom: 10px;
    transform: none;
    gap: 8px;
    padding: 8px;
  }

  .lead-btn {
    min-width: 0;
    flex: 1;
    font-size: 12px;
    padding: 11px 10px;
  }
}
</style>
